import { render, staticRenderFns } from "./TratamienoDatosPersonales.vue?vue&type=template&id=8e2e535e"
import script from "./TratamienoDatosPersonales.vue?vue&type=script&lang=js"
export * from "./TratamienoDatosPersonales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports